import "./App.scss";
import React, { useState, useEffect } from "react";
import Header from "./header/Header";
import Hero from "./hero/Hero";
import Footer from "./footer/Footer";
import Portfolio from "./portfolio/Portfolio";
import Companies from "./companies/Companies";
import PersonalProjects from "./personal-projects/PersonalProjects";

function App() {
  const [data, setData] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch("data/content-data.json")
      .then((res) => res.json())
      .then((res) => {
        console.log({ data: res });

        setData(res["content"]);
        setLoaded(true);
      });
  }, []);
  return (
    <div className="App">
      <a id="start"></a>
      <Header />
      {loaded ? (
        <div className="main-container">
          <Hero content={data["hero"]} />
          <Portfolio />
          <Companies brands={data["brands"]} />
          <PersonalProjects />
          <Footer content={data["footer"]} />
        </div>
      ) : null}
    </div>
  );
}

export default App;
